import React from "react";
import ReactQuill from "react-quill";

export function InputField({
  label,
  name,
  value,
  onChange,
  type = "text",
  placeholder = "",
}) {
  return (
    <div>
      <label className="mb-1 block text-sm font-bold text-slate-700 dark:text-slate-200">
        {label}
      </label>

      <input
        type={type}
        name={name}
        value={value ?? ""}
        onChange={onChange}
        placeholder={placeholder}
        className="w-full rounded-2xl border border-slate-200 bg-white px-3 py-2 text-sm text-slate-900 outline-none transition focus:ring-2 focus:ring-primary/40 dark:border-white/10 dark:bg-slate-950 dark:text-white"
      />
    </div>
  );
}

export function ColorField({ label, name, value, onChange }) {
  return (
    <div>
      <label className="mb-1 block text-sm font-bold text-slate-700 dark:text-slate-200">
        {label}
      </label>

      <div className="flex items-center gap-3 rounded-2xl border border-slate-200 bg-white p-2 dark:border-white/10 dark:bg-slate-950">
        <input
          type="color"
          name={name}
          value={value || "#013E8E"}
          onChange={onChange}
          className="h-10 w-14 cursor-pointer rounded-xl border-0 bg-transparent p-0"
        />

        <span className="text-sm font-bold text-slate-700 dark:text-slate-200">
          {value || "#013E8E"}
        </span>
      </div>
    </div>
  );
}

export function SelectField({ label, name, value, onChange, children }) {
  return (
    <div>
      <label className="mb-1 block text-sm font-bold text-slate-700 dark:text-slate-200">
        {label}
      </label>

      <select
        name={name}
        value={value ?? ""}
        onChange={onChange}
        className="w-full rounded-2xl border border-slate-200 bg-white px-3 py-2 text-sm font-bold text-slate-700 outline-none transition focus:ring-2 focus:ring-primary/40 dark:border-white/10 dark:bg-slate-950 dark:text-slate-200"
      >
        {children}
      </select>
    </div>
  );
}

export function QuillField({ label, value, onChange, minHeight = 160 }) {
  return (
    <div>
      <label className="mb-1 block text-sm font-bold text-slate-700 dark:text-slate-200">
        {label}
      </label>

      <div className="overflow-hidden rounded-2xl border border-slate-200 bg-white dark:border-white/10 dark:bg-slate-950">
        <ReactQuill
          value={value || ""}
          onChange={onChange}
          theme="snow"
          className="settings-quill dark:text-white"
          style={{ minHeight }}
        />
      </div>
    </div>
  );
}

export function ImageUrlField({
  label,
  name,
  value,
  onChange,
  preview,
  placeholder = "https://... ou /uploads/...",
}) {
  return (
    <div>
      <label className="mb-1 block text-sm font-bold text-slate-700 dark:text-slate-200">
        {label}
      </label>

      <div className="grid gap-3 rounded-2xl border border-slate-200 bg-white p-3 dark:border-white/10 dark:bg-slate-950 sm:grid-cols-[1fr_120px]">
        <input
          type="text"
          name={name}
          value={value ?? ""}
          onChange={onChange}
          placeholder={placeholder}
          className="w-full rounded-xl border border-slate-200 bg-white px-3 py-2 text-sm text-slate-900 outline-none transition focus:ring-2 focus:ring-primary/40 dark:border-white/10 dark:bg-slate-900 dark:text-white"
        />

        <div className="h-20 overflow-hidden rounded-xl bg-slate-100 dark:bg-slate-900">
          <img
            src={preview}
            alt={label}
            className="h-full w-full object-cover"
            onError={(event) => {
              event.currentTarget.src = "/images/asso_placeholder.webp";
            }}
          />
        </div>
      </div>
    </div>
  );
}